
export function authHeader() {
    // New login flow: token stored as plain string under 'ivec_token'.
    const token = localStorage.getItem('ivec_token');
    if (token) {
        return { Authorization: 'Bearer ' + token };
    }

    // Legacy format: user object with { token, username } stored under 'user'.
    try {
        const user = JSON.parse(localStorage.getItem('user'));
        if (user && user.token) {
            return { Authorization: 'Bearer ' + user.token, username: user.username };
        }
    } catch {
        // ignore parse errors
    }

    return {};
}
